import { defaultTheme } from './_themes-vars';

export const styles = {
  // ==============================|| LIGHT BOX ||============================== //
  slickArrow: {
    '&:before': {
      color: defaultTheme.grey500
    }
  },

  fullscreenBlanket: {
    zIndex: 1200
  },

  // ==============================|| PERFECT SCROLLBAR ||============================== //
  scrollbarThumbY: {
    backgroundColor: defaultTheme.grey500,
    borderRadius: '6px',
    width: '5px',
    right: 0
  },
  scrollbarThumbYHover: {
    backgroundColor: defaultTheme.grey500,
    width: '5px'
  },

  scrollbarRailYActive: {
    width: '5px',
    backgroundColor: 'transparent',
    zIndex: 999
  },
  scrollbarScrollingY: {
    opacity: 0.4,
    backgroundColor: 'transparent'
  },

  // ==============================|| CLEARABLE INPUT ||============================== //
  clearableInput: {
    position: 'relative',
    input: {
      paddingRight: '2.5rem'
    },
    svg: {
      position: 'absolute',
      top: 0,
      right: 0,
      paddingTop: '10px',
      paddingRight: '10px',
      fontWeight: 'bold',
      cursor: 'pointer'
    }
  },

  // ==============================|| ANIMATIONS ||============================== //
  '@keyframes wings': {
    '50%': { transform: 'translateY(-40px)' },
    '100%': { transform: 'translateY(0px)' }
  },
  '@keyframes blink': {
    '50%': { opacity: 0 },
    '100%': { opacity: 1 }
  },
  '@keyframes bounce': {
    '0%, 20%, 53%, 100%': {
      animationTimingFunction: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
      transform: 'translateZ(0)'
    },
    '40%, 43%': {
      animationTimingFunction: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
      transform: 'translate3d(0, -5px, 0)'
    },
    '70%': {
      animationTimingFunction: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
      transform: 'translate3d(0, -7px, 0)'
    },
    '80%': {
      transitionTimingFunction: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
      transform: 'translateZ(0)'
    },
    '90%': {
      transform: 'translate3d(0, -2px, 0)'
    }
  },
  '@keyframes slideY': {
    '0%, 50%, 100%': { transform: 'translateY(0px)' },
    '25%': { transform: 'translateY(-10px)' },
    '75%': { transform: 'translateY(10px)' }
  },
  '@keyframes slideX': {
    '0%, 50%, 100%': { transform: 'translateX(0px)' },
    '25%': { transform: 'translateX(-10px)' },
    '75%': { transform: 'translateX(10px)' }
  },

  // ==============================|| PREBUILD SLIDER ||============================== //
  preBuildDashBoardSlider: {
    overflow: 'hidden',
    '.slider': {
      '.slide': {
        opacity: 0.5,
        display: 'flex',
        justifyContent: 'center',
        '&.selected': {
          opacity: 1,
          '.custom-slider': {
            display: 'flex',
            flexDirection: 'column',
            gap: '40px'
          }
        },
        '&:not(.selected)': {
          transform: 'scale(0.7)',
          transformOrigin: 'top'
        }
      }
    }
  },

  // ==============================|| PROJECT INFO ||============================== //
  projectInfo: {
    '.project-slider': {
      '.slick-list': {
        padding: 0
      }
    },
    '.slick-slide': {
      opacity: 0.05
    },
    '.slick-active': {
      opacity: 0.2
    },
    '.slick-current': {
      opacity: 1,
      '.MuiTypography-root': {
        color: defaultTheme.primaryMain
      }
    }
  },

  rilInner: {
    direction: 'ltr'
  },

  reactModalOverlay: {
    zIndex: 99999
  }
};
